var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 947,
    viewBox: "0 0 640 947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12862_71849)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12862_71849)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -76,
    width: 640,
    height: 1100,
    fill: "#00102F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.72 425.04C220.72 433.4 214.6 439.28 206.72 439.28C198.88 439.28 192.72 433.4 192.72 425.04C192.72 416.68 198.88 410.8 206.72 410.8C214.6 410.8 220.72 416.68 220.72 425.04ZM196.44 425.04C196.44 431.84 200.84 436.12 206.72 436.12C212.6 436.12 217 431.84 217 425.04C217 418.2 212.6 413.96 206.72 413.96C200.84 413.96 196.44 418.2 196.44 425.04ZM229.165 421.12C230.485 418.8 233.365 416.72 237.365 416.72C243.245 416.72 247.765 421.12 247.765 427.96C247.765 434.76 243.245 439.36 237.365 439.36C233.365 439.36 230.525 437.2 229.165 434.96V449.4H225.525V417.08H229.165V421.12ZM244.045 427.96C244.045 422.8 240.645 419.88 236.605 419.88C232.645 419.88 229.165 422.92 229.165 428C229.165 433.16 232.645 436.16 236.605 436.16C240.645 436.16 244.045 433.12 244.045 427.96ZM253.357 433V420.08H250.517V417.08H253.357V411.56H256.997V417.08H262.717V420.08H256.997V433C256.997 435.16 257.797 435.92 260.037 435.92H262.717V439H259.437C255.557 439 253.357 437.4 253.357 433ZM267.127 439V417.08H270.767V439H267.127ZM269.007 413.52C267.607 413.52 266.527 412.44 266.527 411.04C266.527 409.64 267.607 408.56 269.007 408.56C270.327 408.56 271.407 409.64 271.407 411.04C271.407 412.44 270.327 413.52 269.007 413.52ZM308.611 439V426.6C308.611 422.12 306.211 419.84 302.611 419.84C298.931 419.84 296.411 422.2 296.411 426.92V439H292.811V426.6C292.811 422.12 290.411 419.84 286.811 419.84C283.131 419.84 280.611 422.2 280.611 426.92V439H276.971V417.08H280.611V420.24C282.051 417.92 284.651 416.68 287.531 416.68C291.131 416.68 294.131 418.28 295.571 421.56C296.851 418.4 299.971 416.68 303.331 416.68C308.331 416.68 312.211 419.8 312.211 426.08V439H308.611ZM318.182 439V417.08H321.822V439H318.182ZM320.062 413.52C318.662 413.52 317.582 412.44 317.582 411.04C317.582 409.64 318.662 408.56 320.062 408.56C321.382 408.56 322.462 409.64 322.462 411.04C322.462 412.44 321.382 413.52 320.062 413.52ZM341.425 417.08V420.04L330.745 436H341.505V439H326.585V436L337.225 420.04H326.665V417.08H341.425ZM355.548 419.8C351.988 419.8 349.028 422.16 348.628 426.44H362.468C362.508 422.16 359.308 419.8 355.548 419.8ZM365.788 432.24C364.668 436.24 361.148 439.36 355.708 439.36C349.468 439.36 344.868 434.96 344.868 428C344.868 421.08 349.308 416.72 355.708 416.72C362.068 416.72 366.228 421.2 366.228 427.2C366.228 428 366.188 428.64 366.108 429.4H348.588C348.868 433.84 351.988 436.28 355.708 436.28C358.988 436.28 361.068 434.6 361.868 432.24H365.788ZM390.017 434.84L396.817 417.08H400.577L387.377 449.32H383.617L387.937 438.76L379.097 417.08H383.137L390.017 434.84ZM425.036 428C425.036 434.96 420.036 439.36 413.796 439.36C407.596 439.36 402.876 434.96 402.876 428C402.876 421.08 407.756 416.72 413.956 416.72C420.196 416.72 425.036 421.08 425.036 428ZM406.596 428C406.596 433.56 409.996 436.16 413.796 436.16C417.596 436.16 421.316 433.56 421.316 428C421.316 422.48 417.676 419.88 413.916 419.88C410.076 419.88 406.596 422.48 406.596 428ZM449.262 417.08V439H445.622V435.76C444.222 438.04 441.542 439.32 438.622 439.32C433.582 439.32 429.622 436.2 429.622 429.92V417.08H433.222V429.44C433.222 433.88 435.662 436.16 439.342 436.16C443.102 436.16 445.622 433.84 445.622 429.12V417.08H449.262ZM459.048 427.08V439H455.408V417.08H459.048V420.64C460.288 418.2 462.648 416.68 466.128 416.68V420.44H465.168C461.688 420.44 459.048 422 459.048 427.08ZM209 467.32C209 464.16 207.24 462.12 203.08 462.12H197.72V472.68H203.08C207.2 472.68 209 470.44 209 467.32ZM194.08 459.12H203.08C209.64 459.12 212.76 462.76 212.76 467.32C212.76 470.88 210.8 474.28 206.12 475.32L213.12 487H208.76L202.12 475.6H197.72V487H194.08V459.12ZM227.736 467.8C224.176 467.8 221.216 470.16 220.816 474.44H234.656C234.696 470.16 231.496 467.8 227.736 467.8ZM237.976 480.24C236.856 484.24 233.336 487.36 227.896 487.36C221.656 487.36 217.056 482.96 217.056 476C217.056 469.08 221.496 464.72 227.896 464.72C234.256 464.72 238.416 469.2 238.416 475.2C238.416 476 238.376 476.64 238.296 477.4H220.776C221.056 481.84 224.176 484.28 227.896 484.28C231.176 484.28 233.256 482.6 234.056 480.24H237.976ZM258.981 481.04C258.981 484.64 255.821 487.36 250.981 487.36C245.861 487.36 242.261 484.56 242.021 480.56H245.781C245.981 482.68 247.861 484.28 250.941 484.28C253.821 484.28 255.421 482.84 255.421 481.04C255.421 476.16 242.461 479 242.461 470.84C242.461 467.48 245.621 464.72 250.501 464.72C255.341 464.72 258.541 467.32 258.781 471.6H255.141C254.981 469.4 253.301 467.8 250.381 467.8C247.701 467.8 246.101 469.08 246.101 470.84C246.101 476.04 258.821 473.2 258.981 481.04ZM264.919 481V468.08H262.079V465.08H264.919V459.56H268.559V465.08H274.279V468.08H268.559V481C268.559 483.16 269.359 483.92 271.599 483.92H274.279V487H270.999C267.119 487 264.919 485.4 264.919 481ZM277.329 475.96C277.329 469.12 281.849 464.72 287.729 464.72C291.809 464.72 294.609 466.8 295.889 469.08V465.08H299.569V487H295.889V482.92C294.569 485.28 291.729 487.36 287.689 487.36C281.849 487.36 277.329 482.76 277.329 475.96ZM295.889 476C295.889 470.92 292.449 467.88 288.449 467.88C284.449 467.88 281.049 470.8 281.049 475.96C281.049 481.12 284.449 484.16 288.449 484.16C292.449 484.16 295.889 481.16 295.889 476ZM325.161 465.08V487H321.521V483.76C320.121 486.04 317.441 487.32 314.521 487.32C309.481 487.32 305.521 484.2 305.521 477.92V465.08H309.121V477.44C309.121 481.88 311.561 484.16 315.241 484.16C319.001 484.16 321.521 481.84 321.521 477.12V465.08H325.161ZM334.947 475.08V487H331.307V465.08H334.947V468.64C336.187 466.2 338.547 464.68 342.027 464.68V468.44H341.067C337.587 468.44 334.947 470 334.947 475.08ZM344.868 475.96C344.868 469.12 349.388 464.72 355.268 464.72C359.348 464.72 362.148 466.8 363.428 469.08V465.08H367.108V487H363.428V482.92C362.108 485.28 359.268 487.36 355.228 487.36C349.388 487.36 344.868 482.76 344.868 475.96ZM363.428 476C363.428 470.92 359.988 467.88 355.988 467.88C351.988 467.88 348.588 470.8 348.588 475.96C348.588 481.12 351.988 484.16 355.988 484.16C359.988 484.16 363.428 481.16 363.428 476ZM389.3 487V474.6C389.3 470.12 386.86 467.84 383.18 467.84C379.46 467.84 376.9 470.16 376.9 474.88V487H373.26V465.08H376.9V468.2C378.34 465.92 380.98 464.68 383.94 464.68C389.02 464.68 392.9 467.8 392.9 474.08V487H389.3ZM399.646 481V468.08H396.806V465.08H399.646V459.56H403.286V465.08H409.006V468.08H403.286V481C403.286 483.16 404.086 483.92 406.326 483.92H409.006V487H405.726C401.846 487 399.646 485.4 399.646 481ZM414.176 468.2H411.616L413.976 459.12H418.016L414.176 468.2ZM437.926 481.04C437.926 484.64 434.766 487.36 429.926 487.36C424.806 487.36 421.206 484.56 420.966 480.56H424.726C424.926 482.68 426.806 484.28 429.886 484.28C432.766 484.28 434.366 482.84 434.366 481.04C434.366 476.16 421.406 479 421.406 470.84C421.406 467.48 424.566 464.72 429.446 464.72C434.286 464.72 437.486 467.32 437.726 471.6H434.086C433.926 469.4 432.246 467.8 429.326 467.8C426.646 467.8 425.046 469.08 425.046 470.84C425.046 476.04 437.766 473.2 437.926 481.04ZM197.72 520.36H203.08C207.24 520.36 209 518.4 209 515.28C209 512.04 207.24 510.12 203.08 510.12H197.72V520.36ZM212.72 515.28C212.72 519.52 210 523.36 203.08 523.36H197.72V535H194.08V507.12H203.08C209.64 507.12 212.72 510.72 212.72 515.28ZM220.884 523.08V535H217.244V513.08H220.884V516.64C222.124 514.2 224.484 512.68 227.964 512.68V516.44H227.004C223.524 516.44 220.884 518 220.884 523.08ZM252.966 524C252.966 530.96 247.966 535.36 241.726 535.36C235.526 535.36 230.806 530.96 230.806 524C230.806 517.08 235.686 512.72 241.886 512.72C248.126 512.72 252.966 517.08 252.966 524ZM234.526 524C234.526 529.56 237.926 532.16 241.726 532.16C245.526 532.16 249.246 529.56 249.246 524C249.246 518.48 245.606 515.88 241.846 515.88C238.006 515.88 234.526 518.48 234.526 524ZM258.432 535V516.08H255.592V513.08H258.432V511.52C258.432 506.64 260.832 504.44 266.432 504.44V507.48C263.152 507.48 262.072 508.68 262.072 511.52V513.08H266.672V516.08H262.072V535H258.432ZM270.916 535V513.08H274.556V535H270.916ZM272.796 509.52C271.396 509.52 270.316 508.44 270.316 507.04C270.316 505.64 271.396 504.56 272.796 504.56C274.116 504.56 275.196 505.64 275.196 507.04C275.196 508.44 274.116 509.52 272.796 509.52ZM281.56 529V516.08H278.72V513.08H281.56V507.56H285.2V513.08H290.92V516.08H285.2V529C285.2 531.16 286 531.92 288.24 531.92H290.92V535H287.64C283.76 535 281.56 533.4 281.56 529ZM293.97 523.96C293.97 517.12 298.49 512.72 304.37 512.72C308.45 512.72 311.25 514.8 312.53 517.08V513.08H316.21V535H312.53V530.92C311.21 533.28 308.37 535.36 304.33 535.36C298.49 535.36 293.97 530.76 293.97 523.96ZM312.53 524C312.53 518.92 309.09 515.88 305.09 515.88C301.09 515.88 297.69 518.8 297.69 523.96C297.69 529.12 301.09 532.16 305.09 532.16C309.09 532.16 312.53 529.16 312.53 524ZM326.001 517.16C327.401 514.72 330.321 512.72 334.201 512.72C340.121 512.72 344.601 517.12 344.601 523.96C344.601 530.76 340.081 535.36 334.201 535.36C330.201 535.36 327.361 533.36 326.001 530.96V535H322.361V505.4H326.001V517.16ZM340.881 523.96C340.881 518.8 337.481 515.88 333.441 515.88C329.481 515.88 326.001 518.92 326.001 524C326.001 529.16 329.481 532.16 333.441 532.16C337.481 532.16 340.881 529.12 340.881 523.96ZM349.393 535V513.08H353.033V535H349.393ZM351.273 509.52C349.873 509.52 348.793 508.44 348.793 507.04C348.793 505.64 349.873 504.56 351.273 504.56C352.593 504.56 353.673 505.64 353.673 507.04C353.673 508.44 352.593 509.52 351.273 509.52ZM359.236 535V505.4H362.876V535H359.236ZM369.08 535V513.08H372.72V535H369.08ZM370.96 509.52C369.56 509.52 368.48 508.44 368.48 507.04C368.48 505.64 369.56 504.56 370.96 504.56C372.28 504.56 373.36 505.64 373.36 507.04C373.36 508.44 372.28 509.52 370.96 509.52ZM379.724 529V516.08H376.884V513.08H379.724V507.56H383.364V513.08H389.084V516.08H383.364V529C383.364 531.16 384.164 531.92 386.404 531.92H389.084V535H385.804C381.924 535 379.724 533.4 379.724 529ZM401.814 530.84L408.614 513.08H412.374L399.174 545.32H395.414L399.734 534.76L390.894 513.08H394.934L401.814 530.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -95,
    y: 44,
    width: 326,
    height: 311,
    rx: 15,
    fill: "#012057"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -68,
    y: 106,
    width: 223,
    height: 30,
    rx: 15,
    fill: "#022D75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -68,
    y: 106,
    width: 171,
    height: 30,
    rx: 15,
    fill: "#063B92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -68,
    y: 184,
    width: 223,
    height: 30,
    rx: 15,
    fill: "#022D75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -68,
    y: 184,
    width: 123,
    height: 30,
    rx: 15,
    fill: "#063B92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -68,
    y: 262,
    width: 223,
    height: 30,
    rx: 15,
    fill: "#022D75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722,
    y: 517,
    width: 194,
    height: 30,
    rx: 15,
    transform: "rotate(180 722 517)",
    fill: "#012057"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -68,
    y: 262,
    width: 200,
    height: 30,
    rx: 15,
    fill: "#063B92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722,
    y: 517,
    width: 161,
    height: 30,
    rx: 15,
    transform: "rotate(180 722 517)",
    fill: "#063B92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722,
    y: 574,
    width: 161,
    height: 30,
    rx: 15,
    transform: "rotate(180 722 574)",
    fill: "#012057"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 722,
    y: 574,
    width: 126,
    height: 30,
    rx: 15,
    transform: "rotate(180 722 574)",
    fill: "#063B92"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 277,
    r: 15,
    stroke: "#063B92",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 765,
    r: 15,
    fill: "#063B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5 771V814C155.5 825.046 164.454 834 175.5 834H377",
    stroke: "#063B92",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407,
    cy: 91,
    r: 47,
    fill: "#022D75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 91C454 82.5755 451.736 74.3059 447.444 67.0566C443.152 59.8073 436.991 53.8447 429.605 49.7929C422.219 45.7412 413.879 43.7491 405.459 44.0253C397.039 44.3014 388.849 46.8356 381.744 51.3626L407 91H454Z",
    fill: "#063B92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 51,
    width: 190,
    height: 80,
    rx: 10,
    fill: "#063B92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 173,
    width: 310,
    height: 160,
    rx: 10,
    fill: "#012057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 281.047L465.69 222.357L540.643 271.855L598.272 214.225",
    stroke: "#063B92",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 635,
    width: 242,
    height: 102,
    rx: 10,
    fill: "#012057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 668H256",
    stroke: "#063B92",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 704L234 704",
    stroke: "#063B92",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 77H661",
    stroke: "#00102F",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 105L644 105",
    stroke: "#00102F",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 540,
    cy: 846.5,
    rx: 137.5,
    ry: 137,
    transform: "rotate(-90 540 846.5)",
    stroke: "#022D75",
    strokeWidth: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.981 864.234C407.499 891.2 418.906 916.521 436.758 936.996C454.611 957.47 478.108 972.177 504.277 979.258C530.447 986.339 558.113 985.476 583.779 976.777C609.445 968.078 631.956 951.934 648.467 930.387C664.978 908.84 674.747 882.858 676.538 855.726C678.329 828.594 672.062 801.53 658.53 777.958C644.997 754.386 624.807 735.364 600.512 723.297C584.303 715.245 566.752 710.532 548.885 709.327",
    stroke: "#063B92",
    strokeWidth: 70
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 298.5H674.5",
    stroke: "#022D75",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.706 197.615C614.405 197.271 615.911 198.714 615.68 200.399L615.653 200.563L610.095 227.979C609.699 229.933 607.287 230.66 605.877 229.25L584.018 207.391L583.892 207.256C582.695 205.878 583.351 203.703 585.11 203.216L585.289 203.173L612.706 197.615Z",
    fill: "#063B92",
    stroke: "#063B92",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12862_71849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 1100,
    fill: "white",
    transform: "translate(0 -76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12862_71849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 1100,
    fill: "white",
    transform: "translate(0 -76)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/LoginImage.19146178c3cc1a9bcdd4ad00cea6771f.svg";
export { ForwardRef as ReactComponent };